import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./WarehouseSelectionForm";
import {WAREHOUSE_IDS} from "../../queries/inventory";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelAssignWarehouseToLocation} from "../../actions/ShippingApiActions";
import {fromJS, Map} from "immutable";
import {validatePresence} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "warehouseId");
  return errors.toJS();
}

class AssignWarehouseToLocationFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let warehouseId = values.get("warehouseId");
    if (this.props.kind === "country") {

      return this.props.assignWarehouseToCountry({country_code: this.props.code, warehouseId: warehouseId})
        .then((response) => {
          if (response.data.assignWarehouseToCountry.errors.length <= 0) {
            this.props.cancelAssignWarehouseToLocation();
          } else {
            let errors = createValidationErrors(response.data.assignWarehouseToCountry.errors);
            this.setState({errors: errors});
          }
        })
        .catch((err) => {
          this.setState({errors: createErrors(err)});
        });      

    } else {

      return this.props.assignWarehouseToUsState({state_code: this.props.code, warehouseId: warehouseId})
        .then((response) => {
          if (response.data.assignWarehouseToUsState.errors.length <= 0) {
            this.props.cancelAssignWarehouseToLocation();
          } else {
            let errors = createValidationErrors(response.data.assignWarehouseToUsState.errors);
            this.setState({errors: errors});
          }
        })
        .catch((err) => {
          this.setState({errors: createErrors(err)});
        });      

    }
  }

  handleCancel() {
    this.props.cancelAssignWarehouseToLocation();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let warehouses = fromJS(data.warehouses).map((warehouse) => {
      return Map({
        id: warehouse.get("id"),
        label: `${warehouse.get("id")} (${warehouse.getIn(["info", "system"], "")})`
      })
    });
    let initialValues = fromJS({
      warehouseId: this.props.warehouseId
    })
    return (
      <Form
        initialValues={initialValues}
        warehouses={warehouses}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const ASSIGN_TO_COUNTRY = gql`
  mutation assignWarehouseToCountry($data: AssignWarehouseToCountryInput!) {
    assignWarehouseToCountry(input: $data) {
      errors { key message }
    }
  }
`;

const ASSIGN_TO_US_STATE = gql`
  mutation assignWarehouseToUsState($data: AssignWarehouseToUsStateInput!) {
    assignWarehouseToUsState(input: $data) {
      errors { key message }
    }
  }
`;

const withQuery = compose(
  graphql(WAREHOUSE_IDS, {
    options: {
      fetchPolicy: "network-only"
    }
  }),
  graphql(ASSIGN_TO_COUNTRY, {
    props: ({ mutate }) => ({
      assignWarehouseToCountry: (data) => mutate({
        variables: { data: data }
      })
    })
  }),
  graphql(ASSIGN_TO_US_STATE, {
    props: ({ mutate }) => ({
      assignWarehouseToUsState: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

const AssignWarehouseToLocationFormContainerWithData = withQuery(AssignWarehouseToLocationFormContainer);

export default connect(null, {cancelAssignWarehouseToLocation})(AssignWarehouseToLocationFormContainerWithData);